<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="日期">
                    <a-date-picker v-model:value="date" valueFormat="YYYY-MM-DD" style="width:200px" placeholder="全部"
                        @change="loadtable" />
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" v-loading="loading"
                :rowKey="(record, index) => { return index }" :pagination="false">
                <span slot="subtitle" slot-scope="row">
                    <div v-html="row.subtitle" style="white-space:pre-wrap"></div>
                </span>
                <span slot="title_str" slot-scope="row">
                    <div v-html="row.title_str" style="white-space:pre-wrap"></div>
                </span>
                <span slot="task_row" slot-scope="row">
                    <span v-if="row.msg != ''">{{ row.msg }}</span>
                    <template v-else>
                        <el-link :href="row.video_url" type="primary" target="_blank" v-if="row.video_url">查看</el-link>
                        <span v-else class="btn2">未合成</span>
                        |
                        <el-link type="primary" v-if="row.canre" @click="revideo(row)">重置</el-link>
                        <span v-else class="btn2">已发布</span>
                    </template>
                </span>
            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            table: null,
            loading: false,
            date: '',
            showPagination: false,
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                }, {
                    title: "客户",
                    dataIndex: "company",
                    width: 200,
                }, {
                    title: "标题",
                    dataIndex: "p_title",
                    width: 400,
                }, {
                    title: "字幕",
                    scopedSlots: { customRender: "subtitle" },
                    width: 400,
                }, {
                    title: "标题组",
                    scopedSlots: { customRender: "title_str" },
                    width: 400,
                }, {
                    title: "操作",
                    scopedSlots: { customRender: "task_row" },
                    width: 200,
                }, {
                    title: ''
                }
            ]
        };
    },
    created() {
        this.date = this.$moment().format("YYYY-MM-DD");
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            get("/video/admin_task_json", {
                date: this.date,
            }).then((res) => {
                this.loading = false;
                this.table = res.data;
            });
        },
        revideo(row) {
            this.loading = true;
            post("/video/ag_revideo?video_id=" + row.video_id).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    this.$message.success("已重置，新任务正在生成，稍后刷新页面查看。")
                    row.msg="已重置";
                } else {
                    this.$message.error(res.msg)
                }
            });
        }
    }
}
</script>
